module.exports = __webpack_public_path__ + "img/direction-rtl.8c068bb2.svg";